<template>
  <!-- Header content -->
  <div
      :class="[
        'flex h-12 justify-between items-center py-1.5 px-6 w-full w-full md:max-w-md mx-auto sticky top-0',
        variant === 'auth' ? 'bg-inherit shadow-box z-10' : 'bg-gray-900 text-gray-100',
        variant === 'profile' ? 'relative' : ''
      ]"
      style="padding-top: 0.375rem; z-index: 40;">
    <div :class="['flex items-center w-full', variant === 'profile' ? 'justify-between' : 'justify-between']">
      <!-- Left side: Notifications or Sport selector -->
      <GameNotificationBell
          v-if="showProfile"
          :count="unreadCount"
          @click="notificationsOpen = true"
      />
      <div v-if="showSportSelector" class="flex-shrink-0">
        <slot name="sport-selector"></slot>
      </div>
      <div v-else class="flex-shrink-0">
        <div></div>
      </div>

      <!-- Center: Title or Logo -->
      <p v-if="title" :class="['font-semibold', variant === 'auth' ? 'text-lg text-white' : 'text-lg']">
        {{ title }}
      </p>
      <NuxtLink v-if="showLogo" @click="navigateTo({name: 'index'})"
                class="absolute left-1/2 top-1/2 transform -translate-x-1/2 -translate-y-1/2 flex items-center justify-center">
        <img src="/assets/logo.png" alt="Logo" class="h-[1.7rem] object-contain" style="height: 1.7rem;"/>
      </NuxtLink>

      <!-- Right side: Back button or spacer -->
      <button v-if="showBack" @click="handleBack"
              :class="['bg-transparent border-0 p-0', variant === 'profile' ? 'flex-shrink-0' : '']">
        <TheNuxtIcon name="arrow-left" icon-type="svg"
                     :class="['cursor-pointer text-gray-100', variant === 'auth' ? 'text-xl text-white' : 'text-2xl']"/>
      </button>
      <div v-else-if="showSpacer" style="padding-right:20px"></div>
    </div>
  </div>
  <GameNotificationSheet
      v-if="showProfile"
      v-model="notificationsOpen"
      @refresh="refreshUnreadCount"
  />
</template>

<script lang="ts" setup>
interface Props {
  variant?: 'default' | 'auth' | 'profile'
  showProfile?: boolean
  showLogo?: boolean
  showBack?: boolean
  showSpacer?: boolean
  showSportSelector?: boolean
  title?: string
}

const props = withDefaults(defineProps<Props>(), {
  variant: 'default',
  showProfile: true,
  showLogo: false,
  showBack: true,
  showSpacer: false,
  showSportSelector: false,
  title: ''
})

const router = useRouter()
const { unreadCount, refreshUnreadCount, startPolling } = useGameNotifications()
const notificationsOpen = ref(false)

onMounted(() => {
  refreshUnreadCount()
  startPolling()
})

const handleBack = () => {
  const backwardName = useState<string>('backwardName')
  const backwardTo = useState<any>('backwardTo')
  if (import.meta.client && window.history.length > 1 && window.history.state?.back) {
    router.back()
    return
  }
  if (backwardTo.value) {
    navigateTo(backwardTo.value)
    return
  }
  if (backwardName.value) {
    navigateTo({ name: backwardName.value })
    return
  }
  navigateTo({ name: 'tournaments' })
}
</script>
